import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuLabsSmallIcon extends BaseIcon {
  getChildren = () => [
    <path d="M14.9 15.8c-.1.1-.2.2-.3.2H4.4c-.2 0-.4-.2-.4-.4v-.1L8 6V0h3v6l4 9.5c0 .1 0 .2-.1.3z" fill="#e45785"/>,
    <path d="M6.5 7.3c-.2-.1-.3-.1-.5-.2V3H4v4.1c-1.7.4-3 2-3 3.9 0 1.6 1 3 2.4 3.6l3.1-7.3z" fill="#aeaebc"/>,
    <path d="M5 15c2.2 0 4-1.8 4-4 0-1.4-.7-2.5-1.7-3.3l-3 7.2c.2.1.4.1.7.1z" fill="#9c3b62"/>
    ]
  getViewBox = () => '0 0 16 16'
}
